import React from 'react';
import { useTranslation } from 'react-i18next';

import 'ui-library/components/Table/Table.css';

import Card from '../../../../../../../../../../components/Card/Card';
import SumBarChart from '../../../Overview/components/SumBarChart/SumBarChart';

const Details = ({
    portfolioId, currency, clientId,
}: {
    portfolioId: number | string;
    clientId: number | string;
    currency: string;
}) => {
    const { t } = useTranslation();

    return (
        <Card title={`${t('cashFlows.inflows')} ${new Date().getFullYear()}`}>
            <SumBarChart
                portfolioId={portfolioId}
                clientId={clientId}
                currency={currency}
            />
        </Card>
    );
};

export default Details;
